import React, { useEffect, useState } from 'react';
import { AttendanceSheetNotificationDto } from '@/api.types';
import { Modal, Button } from 'react-bootstrap';
import { attendanceSheetNotificationInFull } from '../../enums/attendance-sheet-notification.enum';
import { format } from 'date-fns';
import { readByIdAttendanceSheet, sendNotification } from '../../attendance-sheet.service';
import { toast } from 'react-toastify';

interface ModalNotificacaoProps {
  show: boolean;
  folha_id: string;
  handleHide: (e: | React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement> | HTMLElement) => void;
}

const ModalNotificacao: React.FC<ModalNotificacaoProps> = ({ show, handleHide, folha_id }) => {
  const [isExecuting, setExecuting] = useState<boolean>();
  const [notificacoes, setNotificacoes] = useState<AttendanceSheetNotificationDto[]>([]);

  useEffect(() => {
    let cancelled = false;

    if (show) {
      readByIdAttendanceSheet(folha_id)
        .then((res) => {
          if (!cancelled) {
            setNotificacoes(res.notificacoes || []);
          }
        })
        .catch((res) => {
          if (!cancelled) {
            toast.error(String(res));
          }
        });
    }

    return () => {
      cancelled = true;
    };
  }, [folha_id, show]);

  if (!show) return null;

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setExecuting(true)
    sendNotification(folha_id)
      .then((res) => {
        toast.success(res ? String(res) : "Notificação enviada")
        handleHide(e)
      })
      .catch((error) => {
        toast.error(String(error))
      }).finally(() => {
        setExecuting(false)
      })
  };

  return (
    <Modal show={show} size="xl" aria-labelledby="contained-modal-title-vcenter" onExit={handleHide} centered>
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Tabela de Notificações Enviadas.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-sm table-striped table-hover">
          <thead>
            <tr>
              <th>Data</th>
              <th>Remetente</th>
              <th>Destinatário</th>
              <th>Tipo</th>
            </tr>
          </thead>
          <tbody className="table-group-divider">
            {notificacoes && notificacoes.map((notificacao, index) => {
              return (
                <tr key={notificacao.id || `notificacao-${index}`}>
                  <th scope="row">
                    {format(notificacao.criadoEm, 'dd/MM/yyyy HH:mm')}
                  </th>
                  <td>
                    {notificacao.remetente?.nome}
                  </td>
                  <td>
                    {notificacao.destinatario?.nome}
                  </td>
                  <td>
                    {attendanceSheetNotificationInFull(notificacao.tipo)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer className="text-left">
        <Button variant="primary"
          onClick={handleSubmit}
          title='Enviar notificação.'
          disabled={isExecuting}
          style={{ cursor: isExecuting ? 'not-allowed' : 'pointer', }}
        >
          {isExecuting ? 'Aguarde...' : 'Notificar'}
        </Button>
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export default ModalNotificacao;
